import React from "react";
import { Card } from "@/components/ui/card";
import { fmtInt } from "./utils";

export function ReachStat({ live }) {
  const totals = live.reduce(
    (acc, c) => ({
      views: acc.views + Number(c.views || 0),
      likes: acc.likes + Number(c.likes || 0),
      comments: acc.comments + Number(c.comments || 0),
      shares: acc.shares + Number(c.shares || 0),
      commentsMade: acc.commentsMade + Number(c.comments_made_count || 0),
    }),
    { views: 0, likes: 0, comments: 0, shares: 0, commentsMade: 0 },
  );
  const cells = [
    { label: "Views", value: totals.views, tone: "text-blue-700" },
    { label: "Likes", value: totals.likes, tone: "text-rose-700" },
    { label: "Comments", value: totals.comments, tone: "text-amber-700" },
    { label: "Shares", value: totals.shares, tone: "text-emerald-700" },
    { label: "Comments made", value: totals.commentsMade, tone: "text-indigo-700", testid: "reach-comments-made" },
  ];
  return (
    <Card className="p-3 sm:p-4 border border-slate-200 shadow-none" data-testid="campaign-total-reach">
      <div className="flex items-baseline justify-between mb-2 sm:mb-3">
        <div>
          <div className="text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.1em] text-slate-500">Campaign total reach</div>
          <div className="text-[10px] sm:text-[11px] text-slate-400">
            Summed across <b>{live.length}</b> live creator{live.length === 1 ? "" : "s"}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 sm:gap-4">
        {cells.map((c) => (
          <div
            key={c.label}
            className="min-w-0"
            data-testid={c.testid || `reach-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className="text-[10px] uppercase tracking-wider text-slate-500">{c.label}</div>
            <div className={`stat-num text-lg sm:text-2xl font-bold mt-0.5 truncate ${c.tone}`}>{fmtInt(c.value)}</div>
          </div>
        ))}
      </div>
    </Card>
  );
}
